import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { HeaderContent, TableSizeType } from '../../../types/reports';
import './styles.css';
import { getTableBorderColor } from '../../../utils/table';
import TableAction from '../../table/TableAction';

interface Props {
  headerContent?: HeaderContent;
  isLoading?: boolean;
  type: TableSizeType;
}

export default function ReportHeader({
  headerContent,
  isLoading,
  type,
}: Props) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  if (!headerContent) return null;

  return (
    <Box
      p={type === 'compact' ? 2 : 4}
      gap={2}
      display="flex"
      flexDirection={isMd ? 'row' : 'column'}
      justifyContent="space-between"
      alignItems={isMd ? 'center' : 'start'}
      borderBottom={`1px solid ${getTableBorderColor(theme, type)}`}>
      <Stack
        flexGrow={1}
        direction={type === 'compact' ? 'column' : 'row'}
        alignItems={type === 'compact' ? 'start' : 'center'}
        gap={type === 'compact' ? 0.5 : 2}>
        <Typography
          variant={type === 'compact' ? 'h3' : 'h2'}
          fontWeight={type === 'compact' ? 'bold' : undefined}>
          {headerContent.title}
        </Typography>
        {headerContent.subtitle && (
          <Typography variant={type === 'compact' ? 'body2' : 'body1'}>
            {headerContent.subtitle}
          </Typography>
        )}
      </Stack>
      {headerContent.action && (
        <TableAction {...headerContent.action} isLoading={isLoading} />
      )}
    </Box>
  );
}
